// Do NOT add "use client" to this file
import { DEPRECATED_backwardsCompatibleValues } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/DEPRECATED_backwardsCompatibleValues";
import { StrictLocalizeFunction } from "@faire/web/common/localization";
import upperFirst from "lodash/upperFirst";

export const getHelmetData = (
  query: string,
  isFromDiscoverUrl: boolean,
  strictLocalize: StrictLocalizeFunction
) => {
  const suppliersSearchTerms = /(wholesalers|wholesaler|wholesaling)[^\s]*/gi;

  let header: string, title: string, description: string;
  /**
   * We want to handle special supplier-aimed search terms such as "coffee wholesalers" or
   * "Toronto wholesaling." This requires a subtle change from the standard title, header,
   * and description; namely, by removing the hard-coded "Wholesale" text right before the
   * query. This case is intended to handle that.
   */
  if (query.match(suppliersSearchTerms)) {
    const queryString = query.replace(
      suppliersSearchTerms,
      // eslint-disable-next-line @faire/no-dollar-symbol-in-strings
      `$& products`
    );

    if (isFromDiscoverUrl) {
      header = strictLocalize(
        {
          id: "yvOyPr",
          defaultMessage: "{queryString} for your store",
          description: {
            text: "Header for Discover pages where the placeholder {queryString} will show user's Google search. This is a variant to handle cases where users enter supplier-based words like 'wholesaler(s)' or 'wholesaling.' For example, - queryString: 'london wholesalers' ==> 'London wholesalers products for your store' - queryString: 'wholesaling coffee' ==> 'Wholesaling coffee products for your store'",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    } else {
      header = queryString;
    }

    if (isFromDiscoverUrl) {
      title = strictLocalize(
        {
          id: "ByyAkV",
          defaultMessage: "Wholesale {queryString} for your store",
          description: {
            text: "Meta title for discover pages where the placeholder {queryString} will show user's Google search. This is a variant to handle cases where users enter supplier-based words like 'wholesaler(s)' or 'wholesaling.' For example, - queryString: 'london wholesalers' ==> 'London wholesalers products for your store' - queryString: 'wholesaling coffee' ==> 'Wholesaling coffee products for your store'",
            img: "https://cdn.faire.com/fastly/b6924d6bff146a90863b19e9d2d514483ce58d7a50d200b4cc8d96bea7c82cd3.png",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    } else {
      title = strictLocalize(
        {
          id: "agyYYQ",
          defaultMessage:
            "Purchase {queryString}. Free Returns & Net 60 Terms on Faire",
          description: {
            text: "Meta title for search page where {queryString} is the user's search. This is a variant to handle cases where users enter supplier-based words like 'wholesaler(s)' or 'wholesaling.' For example, 'london wholesalers' ==> 'Purchase london wholesalers products. Free Returns & Net 60 Terms on Faire.com'",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    }

    description = strictLocalize(
      {
        id: "rvjJ4z",
        defaultMessage:
          "Shop {queryString} and more. Stock up on unique brands and products, with free returns and low order minimums.",
        description: {
          text: "Meta-description for search page where {queryString} is the user's search. This is a variant to handle cases where users enter supplier-based words like 'wholesaler(s)' or 'wholesaling.' For example, 'london wholesalers' ==> 'Shop london wholesalers products and more, with free returns and low order minimums.'",
        },
      },
      DEPRECATED_backwardsCompatibleValues({ queryString })
    );
  } else {
    // remove the word wholesale (and variants) from title
    const queryString = query
      .replace(/(wholesale|whole sale|whole-sale)/gi, "")
      .trim();

    if (isFromDiscoverUrl) {
      header = strictLocalize(
        {
          id: "TWmlrv",
          defaultMessage: "Wholesale {queryString} for your store",
          description: {
            text: "Header for Discover pages where the placeholder {queryString} will show user's Google search.",
            img: "https://cdn.faire.com/fastly/b6924d6bff146a90863b19e9d2d514483ce58d7a50d200b4cc8d96bea7c82cd3.png",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    } else {
      header = strictLocalize(
        {
          id: "4VxC99",
          defaultMessage: "Wholesale {queryString}",
          description: {
            text: "Header text for a search page, {queryString} being the searched term",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    }

    if (isFromDiscoverUrl) {
      title = strictLocalize(
        {
          id: "TU44GZ",
          defaultMessage: "Wholesale {queryString} for your store",
          description: {
            text: "Meta title for discover pages where the placeholder {queryString} will show user's Google search.",
            img: "https://cdn.faire.com/fastly/b6924d6bff146a90863b19e9d2d514483ce58d7a50d200b4cc8d96bea7c82cd3.png",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    } else {
      title = strictLocalize(
        {
          id: "JzNt9u",
          defaultMessage:
            "Purchase Wholesale {queryString}. Free Returns & Net 60 Terms on Faire",
          description: {
            text: "Meta title for a search page, {queryString} being the searched term",
          },
        },
        DEPRECATED_backwardsCompatibleValues({ queryString })
      );
    }

    description = strictLocalize(
      {
        id: "SCHVFZ",
        defaultMessage:
          "Shop wholesale {queryString} and more. Stock up on unique brands and products, with free returns and low order minimums.",
        description: {
          text: "Meta description for search (and Discover) pages, {queryString} being the searched term",
          img: "https://cdn.faire.com/fastly/2c973e575aeb44d593e3e24e077f4788fb873ee003dab7cf0dddbaf411c41de1.png",
        },
      },
      DEPRECATED_backwardsCompatibleValues({ queryString })
    );
  }

  // Use lodash upperFirst instead of capitalize because the latter converts the rest of
  // the string to lower case. Thus, the French 'B2B' will become 'b2b' which is undesired.
  return {
    title: upperFirst(title),
    description: upperFirst(description),
    header: upperFirst(header),
  };
};
